import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { charLimit } from "../../../../utils/commonHelper";
import { getTimeDifference } from "../../../../utils/dateTimeFormat";
import { grp_member1, img_placehlder } from "../../../../assets";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdKeyboardArrowRight } from "react-icons/md";
import CustomModal from "../../../../Components/modals/CustomModal";

const MemberListModal = ({ memberList, setPage, total, show, handleClose }) => {
  // console.log(memberList[0]?._user?._id, "memberList MOdal");
  return (
    <CustomModal
      show={show}
      handleClose={handleClose}
      className={"member_list_modal"}
      size={"lg"}
    >
      <InfiniteScroll
        dataLength={memberList?.length || 0}
        next={() => setPage((prev) => prev + 1)}
        hasMore={memberList?.length < total}
        endMessage={<p style={{ textAlign: "center" }}></p>}
      >
        <div className="card_container_grp">
          <h3 className="text-center">Member List</h3>
          <div className="wrap_card_grp">
            {memberList?.map((data) => (
              <div className="card_grp" key={data?._user?._id}>
                <div className="image_wrap">
                  <Link
                    // to={`/dashboard/group/detail/${data?._group}`}
                    to={`/dashboard/group/groupRequestDrawer/Send_Msg_Req/${data?._user?._id}`}
                  >
                    <img src={data?._user?.profilePicture || img_placehlder} alt="Group Cover" />
                    {/* {data} */}
                  </Link>
                </div>
                <div className="card_content_grp">
                  <Link
                    className="card_group_anchor"
                    // to={`/dashboard/group/detail/${data?._user?._id}`}
                    to={`/dashboard/group/groupRequestDrawer/Send_Msg_Req/${data?._user?._id}`}
                  >
                    <h3 className="card_title_grp">{data?._user?.fullName}</h3>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </InfiniteScroll>
    </CustomModal>
  );
};

export default MemberListModal;
